var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixCalendarV3EventsView from '@wix/ambassador-calendar-v3-events-view/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Event is confirmed. Default value. */
    Status["CONFIRMED"] = "CONFIRMED";
    /** DEPRECATED! AND WILL BE REMOVED SOON */
    Status["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
    /** Event has been cancelled. */
    Status["CANCELLED"] = "CANCELLED";
})(Status || (Status = {}));
export var RecurrenceType;
(function (RecurrenceType) {
    RecurrenceType["UNKNOWN_RECURRENCE_TYPE"] = "UNKNOWN_RECURRENCE_TYPE";
    /** No recurrence, i.e the event is a single event instance. Default. */
    RecurrenceType["NONE"] = "NONE";
    /** The event is the recurrence master defining the recurrence rule, which is the repeat pattern for the events. */
    RecurrenceType["MASTER"] = "MASTER";
    /** The event is an instance of a recurring event. Read only. */
    RecurrenceType["INSTANCE"] = "INSTANCE";
    /** The event is an exceptional instance of a recurring event. Read only. */
    RecurrenceType["EXCEPTION"] = "EXCEPTION";
})(RecurrenceType || (RecurrenceType = {}));
export var Frequency;
(function (Frequency) {
    Frequency["UNKNOWN_FREQUENCY"] = "UNKNOWN_FREQUENCY";
    /** The event repeats every few weeks. */
    Frequency["WEEKLY"] = "WEEKLY";
})(Frequency || (Frequency = {}));
export var Day;
(function (Day) {
    Day["MONDAY"] = "MONDAY";
    Day["TUESDAY"] = "TUESDAY";
    Day["WEDNESDAY"] = "WEDNESDAY";
    Day["THURSDAY"] = "THURSDAY";
    Day["FRIDAY"] = "FRIDAY";
    Day["SATURDAY"] = "SATURDAY";
    Day["SUNDAY"] = "SUNDAY";
})(Day || (Day = {}));
export var Transparency;
(function (Transparency) {
    Transparency["UNKNOWN_TRANSPARENCY"] = "UNKNOWN_TRANSPARENCY";
    /** The event block time. Default. */
    Transparency["OPAQUE"] = "OPAQUE";
    /** The event does not block the time. */
    Transparency["TRANSPARENT"] = "TRANSPARENT";
})(Transparency || (Transparency = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** The event takes place at the business location. */
    LocationType["BUSINESS"] = "BUSINESS";
    /** The event takes place at the customer location. */
    LocationType["CUSTOMER"] = "CUSTOMER";
    /** The event takes place at the custom location. */
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
export var Role;
(function (Role) {
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Role grants full write and read access. */
    Role["WRITER"] = "WRITER";
    /** Role grants full read access and permission to edit notes. */
    Role["COMMENTER"] = "COMMENTER";
})(Role || (Role = {}));
export var ParticipantsStatus;
(function (ParticipantsStatus) {
    ParticipantsStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** All participants are confirmed. */
    ParticipantsStatus["CONFIRMED"] = "CONFIRMED";
    /** Some participants are pending confirmation. */
    ParticipantsStatus["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
})(ParticipantsStatus || (ParticipantsStatus = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["ZOOM"] = "ZOOM";
    Type["CUSTOM"] = "CUSTOM";
})(Type || (Type = {}));
export var Field;
(function (Field) {
    Field["UNKNOWN_FIELD"] = "UNKNOWN_FIELD";
    /** The title is inherited from the schedule or the recurring event. */
    Field["TITLE"] = "TITLE";
    /** The time zone is inherited from the schedule or the recurring event. */
    Field["TIME_ZONE"] = "TIME_ZONE";
    /** The time is inherited from the recurring event. */
    Field["TIME"] = "TIME";
    /** The location is inherited from the schedule or the recurring event. */
    Field["LOCATION"] = "LOCATION";
    /** The resources are inherited from the recurring event. */
    Field["RESOURCES"] = "RESOURCES";
    /** The capacity is inherited from the schedule or the recurring event. */
    Field["CAPACITY"] = "CAPACITY";
    /** The participants are inherited from the recurring event. */
    Field["PARTICIPANTS"] = "PARTICIPANTS";
    /** The conferencing details are inherited from the schedule or the recurring event. */
    Field["CONFERENCING_DETAILS"] = "CONFERENCING_DETAILS";
})(Field || (Field = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["WIX_USER"] = "WIX_USER";
})(IdentityType || (IdentityType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _getEventsViewRequest = {};
const _getEventsViewResponse = {};
/**
 * Retrieves the events view information.
 * E.g. the current view end date, or the future duration in days the view should strive for.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function getEventsView() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getEventsViewRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getEventsViewResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['eventsView']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixCalendarV3EventsView.getEventsView(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=calendar-v3-events-view.universal.js.map